import Vue from "vue";
import Vuex from "vuex";

// import dashboardModule from "./dashboard/index";

import auth from "./auth"
import user from "./user"
import styles from './modules/Styles.js'


Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // dashboard: dashboardModule,
    auth,
    user,
    styles
  },
  state() {
   
  },
  mutations: {
    
  },
  actions: {
    
  },
  getters: {
    
  }
});
